export type VideoType = "movie" | "tv" | "variety";

export interface Video {
  id: string;
  title: string;
  cover: string;
  type: VideoType;
  region: string;
  year: number;
  rating: number;
  views: number;
  updateDate: string;
  director: string;
  actors: string[];
  description: string;
  tags: string[];
}

export interface CategoryInfo {
  type: VideoType;
  name: string;
  slug: string;
  icon: string;
  tagline: string;
  description: string;
}

export const REGION_OPTIONS = ["全部", "华语", "欧美", "日韩", "其他"];

export const YEAR_OPTIONS = [
  { label: "全部", value: "all" },
  { label: "近一年", value: "recent1" },
  { label: "近五年", value: "recent5" },
  { label: "经典", value: "classic" },
];

export const SORT_OPTIONS = [
  { label: "最新", value: "latest" },
  { label: "热门", value: "hot" },
  { label: "评分高", value: "rating" },
];

export type SortValue = "latest" | "hot" | "rating";